/**
 * Layout the usage page and its placeholder both consume (spec 079 FR-016).
 *
 * This file exists because the placeholder written without it got the breakdown grid
 * wrong on the first attempt — `gap-4 sm:grid-cols-2` against the page's actual
 * `gap-6 md:grid-cols-2`, which would have disagreed at every width between the two
 * breakpoints and matched only by luck outside them. The source guard caught it; a reader
 * would have had to notice a placeholder that was subtly the wrong shape at one window
 * size. That is precisely the drift sharing the container is meant to make impossible.
 */

/** The space between the page's cards, shared with the placeholder's blocks. */
export const USAGE_PAGE_GAP = 'gap-6';

/** The page's frame. */
export const USAGE_PAGE_SECTION = `flex flex-1 flex-col ${USAGE_PAGE_GAP} p-6 max-md:px-4 max-md:pt-4 pb-12`;

/**
 * One card, measured like spec 226's `ListCard` (`p-4`, inner `gap-3`) so the Spend
 * tab's cards and the Settings cards share one silhouette (spec 231 research R6). The
 * cards used `px-4 py-3.5` before — two pixels short vertically, which is the kind of
 * drift nobody can name but everybody sees.
 */
export const USAGE_CARD = 'border-border bg-card rounded-lg border p-4';
export const USAGE_CARD_GAP = 'gap-3';
